// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2nsVs","errorLogs":"EditorFooter_errorLogs__UcxlS"};